import React from "react";
import { withAuth } from "shared/context/Auth";
import { withTheme } from "shared/context/Theme";
import Avatar from "backpack-ui/dist/components/avatar";
import config from "../../config";
import TextItem from "../TextItem";
import styles from "./styles.css";
import themes from "./themes";

const UserItem = ({ auth, theme }) => {
  if (auth.isUserSignedIn) {
    const { user } = auth;
    const userMenu = config.getUserDesktopMenu(user);

    return (
      <TextItem
        title={userMenu.title}
        url={userMenu.url}
        submenu={userMenu.submenu}
        className={theme.styles.avatar}
        activeClassName={theme.styles.isActive}
      >
        <Avatar src={user.avatar} alt={user.username} size={40} />
      </TextItem>
    );
  }

  const signInItem = config.getSignInItem();

  return (
    <TextItem
      title={signInItem.title}
      url={signInItem.url}
      className={theme.styles.signInButton}
      activeClassName={theme.styles.isActive}
    />
  );
};

export default withAuth(withTheme(UserItem, styles, themes));
